<script setup lang="ts">
import type { SidebarEmits } from '@/shared/emits/sidebar.emit'
import { useSidebar } from '@/shared/composables/useSidebar'
import SvgIcon from '@/components/common/SvgIcon.vue'
import { ESprites, ESpritesUI } from '@/shared/enum/sprites.enum'

const emit = defineEmits<SidebarEmits>()
const { closeSidebar, handleSidebarNavigation, optionsAccountSidebar, showInternetOnDemandLink } =
  useSidebar(emit)
</script>

<template>
  <div id="sidenav-claro" class="absolute w-full h-sidenav">
    <aside
      id="sidenav-claro-menu"
      class="w-60 h-full shadow-md text-white bg-[#404040] absolute z-20"
      itemscope
      itemtype="http://schema.org/SiteNavigationElement"
    >
      <ul class="relative px-1">
        <li
          :id="optionsAccountSidebar.id"
          :key="optionsAccountSidebar.id"
          class="relative"
          itemprop="name"
        >
          <span
            class="flex items-center h-12 px-6 pt-4 overflow-hidden rounded text-orangey-red-200 text-ellipsis whitespace-nowrap"
          >
            {{ optionsAccountSidebar.title }}
          </span>
          <hr class="m-0 mx-6 mb-1 border-orangey-red-200" />
          <ul
            :id="`${optionsAccountSidebar.id}-options`"
            class="relative"
            aria-labelledby="sidenavSecEx3"
          >
            <li
              v-for="(option, index) in optionsAccountSidebar.options"
              :id="`${optionsAccountSidebar.id}-${index}`"
              :key="`${optionsAccountSidebar.id}-${index}`"
              class="relative"
              itemtype="https://schema.org/MenuItem"
            >
              <a
                class="flex flex-row items-center justify-between text-sm cursor-pointer py-4 mx-6 px-2 h-6 overflow-hidden text-white text-ellipsis whitespace-nowrap rounded hover:text-[#404040] hover:bg-white transition duration-300"
                itemprop="url"
                @click="handleSidebarNavigation(option.name)"
              >
                <span itemprop="name">{{ option.title }}</span>
                <SvgIcon :file="ESprites.UI" :name="ESpritesUI.ARROW" class="w-3 h-3" />
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </aside>
    <div class="absolute z-10 w-full h-full bg-zinc-500/70" @click="closeSidebar"></div>
  </div>
</template>

<style>
.h-sidenav {
  height: calc(100vh - 56px);
}
</style>
